import React from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import classNames from "classnames";

const ListItem = ({ provided, snapshot, customForm, onDelete, onDuplicate, onCopy }) => {
  return (
    <tr ref={provided.innerRef}
      className={classNames("draggable-row", { "is-dragging": snapshot.isDragging })}
      { ...provided.draggableProps }
    >
      <td style={{width: '30px'}} { ...provided.dragHandleProps }>
        <h4 className="light-grey-text">☰</h4>
      </td>
      <td style={{maxWidth: '335px'}}>
        <span>{customForm.title}</span>
        {customForm.description && (
          <span style={{marginLeft: '10px'}} data-tip={customForm.description}>
            <i className="material-icons">chat</i>
            <ReactTooltip />
          </span>
        )}
      </td>
      <td style={{maxWidth: '235px'}}>
        {customForm.all_locations ? (
          <span>All Locations</span>
        ) : (
          <ul className="simple-list">
            {customForm.locations.map(location => (
              <li>{location.name}</li>
            ))}
          </ul>
        )}
      </td>
      <td>
        <button className="btn btn-text pull-right"
          tabIndex={0}
          onClick={() => onDelete(customForm.id)}
          onKeyDown={ e => { if (e.key === 'Enter') { onDelete(customForm.id) } } }
        >
          DELETE
        </button>

        <a className="btn btn-text pull-right"
          tabIndex={0}
          href={`/custom_forms/${customForm.id}/edit`}
        >
          EDIT
        </a>

        <button className="btn btn-text pull-right"
          tabIndex={0}
          onClick={() => { onDuplicate(customForm.id) }}
          onKeyDown={e => { if (e.key === 'Enter') { onDuplicate(customForm.id) } }}
        >
          DUPLICATE
        </button>

        <a className="btn btn-text pull-right"
          tabIndex={0}
          href={`/custom_forms/access_editor?custom_form=${customForm.id}`}
        >
          EDIT ACCESS
        </a>

        {customForm.public_form && (
          <button className="btn btn-text pull-right"
            tabIndex={0}
            onClick={() => onCopy(customForm)}
            onKeyDown={e => { if (e.key === 'Enter') { onCopy(customForm) } }}
          >
            COPY PUBLIC URL
          </button>
        )}
      </td>
    </tr>
  )
}

ListItem.propTypes = {
  customForm: PropTypes.object,
  onDelete: PropTypes.func,
  onDuplicate: PropTypes.func,
  onCopy: PropTypes.func
};

export default ListItem;
